export default __webpack_public_path__ + "static/media/MobileImageItemKo3.2200e577.png";